export class HttpError extends Error {
  status: number;
  statusText: string;
  url: string;
  headers: Headers;
  responseBody: string;

  constructor(
    response: Response,
    responseBody: string,
    queryKey: string[] | string,
  ) {
    const parsedQueryKey = Array.isArray(queryKey) ? queryKey[0] : queryKey;

    super(
      `HTTP error for ${parsedQueryKey}: ${response.status} ${response.statusText}`,
    );
    this.name = 'ReactQuery HttpError';
    this.status = response.status;
    this.statusText = response.statusText;
    this.url = response.url;
    this.headers = response.headers;
    this.responseBody = responseBody;
  }
}
